module.exports = new __parcel__URL__("gritbyteLogo.a0a8d734.jpg").toString();